export type PasswordErrorField = "old" | "new" | "confirm" | "general";

export interface PasswordErrorEntry {
  field: PasswordErrorField;
  message: string;
}

export const PASSWORD_ERROR_CODES: Record<string, PasswordErrorEntry> = {
  "609":  { field: "old",     message: "Password cannot be empty." },
  "608":  { field: "old",     message: "The old password you entered is incorrect." },
  "1901": { field: "confirm", message: "Passwords do not match." },
  "1902": { field: "new",     message: "Password must be at least 8 characters long." },
  "1903": { field: "new",     message: "Password must not contain spaces." },
  "1904": { field: "new",     message: "Password must contain at least one uppercase letter." },
  "1905": { field: "new",     message: "Password must contain at least one lowercase letter." },
  "1906": { field: "new",     message: "Password must contain at least one number." },
  "1907": { field: "new",     message: "Password must contain at least one special character." },
  "1908": { field: "new",     message: "New password must be different from the current password." },
};

export const resolvePasswordError = (
  errorCode: string | number | undefined | null
): PasswordErrorEntry | null => {
  if (errorCode == null) return null;
  return PASSWORD_ERROR_CODES[String(errorCode)] ?? null;
};